import { render, staticRenderFns } from "./RelationTableWithBorders.vue?vue&type=template&id=a0ffb4a6&scoped=true&"
import script from "./RelationTableWithBorders.vue?vue&type=script&lang=js&"
export * from "./RelationTableWithBorders.vue?vue&type=script&lang=js&"
import style0 from "./RelationTableWithBorders.vue?vue&type=style&index=0&id=a0ffb4a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ffb4a6",
  null
  
)

export default component.exports